import React from "react";
import { ExternalLink } from "lucide-react";

export const AnimationEmbed = ({ src, title, testId, className = "" }) => (
  <div className={`flex flex-col items-center gap-4 ${className}`} data-testid={testId}>
    <iframe src={src} title={title} style={{ width: "100%", maxWidth: "420px", aspectRatio: "9/16", border: 0, borderRadius: "14px" }} loading="lazy" data-testid={`${testId}-iframe`}></iframe>
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testId}-fullscreen-btn`}
      className="inline-flex items-center gap-2 border border-white/15 hover:border-[#FF3B30] hover:text-[#FF3B30] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors"
    >
      <ExternalLink size={15} /> Voir l&apos;animation en plein écran
    </a>
  </div>
);
